import { useEffect, useRef } from 'react';

/**
 * Runs a callback once when the condition becomes true.
 * After the callback executes, it will not run again even if the condition changes.
 *
 * @param condition - When true, the callback will execute (only once)
 * @param cb - The effect callback to run once
 */
export const useEffectOnce = (condition: boolean, cb: () => void) => {
  const hasRun = useRef(false);

  useEffect(() => {
    if (condition && !hasRun.current) {
      hasRun.current = true;
      cb();
    }
  }, [condition, cb]);
};
